<template>
  <div>
    <DataTable :headers="headers" :path="path" :filterPath="filterPath" :properties="properties"
               action-buttons-name="InformeAuditoriaActionButton" filter toolbar :toolbar-title="toolbarTitle"
               :search-text="searchText">
      <slot slot="toolbar-table"></slot>
    </DataTable>
    <InformeAuditoriaCreatePopUp v-if="canCreate" ref="creacionPopup"></InformeAuditoriaCreatePopUp>
    <v-btn v-if="canCreate" app dark fixed fab bottom right class="add-button" @click="newPresentacion">
      <v-icon>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'
import InformeAuditoriaCreatePopUp from '../components/fields_components/InformeAuditoriaCreatePopUp.vue'

export default {
  methods: {

    newPresentacion () {
      this.$refs.creacionPopup.showDialog()
    }
  },
  props: {
    actionButtonsName: {
      type: String,
      default: 'InformeAuditoriaActionButton'
    },
    path: {
      type: String,
      default: 'informe-auditoria'
    },
    filterPath: {
      type: String,
      default: 'filters/Informes-auditorias'
    },
    initialProperties: {
      type: Array,
      default: () => { return ['pk', /* 'description', */ 'createdAt', 'reportDescription', 'clubDisplay', 'reportType', 'statusDisplay'] }
    },
    initialHeaders: {
      type: Array,
      default: () => { return [] }
    },
    toolbarTitle: {
      type: String,
      default: 'Informes Generales'
    },
    searchText: {
      type: String,
      default: 'Buscar por descripción o tipo'
    },
    mandatory: {
      type: Boolean,
      default: true
    }
  },

  components: {
    DataTable,
    InformeAuditoriaCreatePopUp
  },

  computed: {
    headers () {
      let headers = [
        { text: 'Codigo', align: 'left', value: 'pk', sortable: false },
        // { text: 'Descripcion', value: 'description', sortable: true },
        { text: 'Creacion', value: 'createdAt', sortable: true },
        { text: 'Informe', value: 'reportDescription', filterField: false },
        { text: 'Club', value: 'club', filterField: true },
        { text: 'Tipo', value: 'reportType', filterField: false },
        { text: 'Estado', value: 'status', filterField: true },
        { text: 'Acciones', align: 'right', sortable: false }
      ]
      return headers
    },
    properties () {
      let properties = this.initialProperties
      return properties
    },
    canCreate () {
      return this.$store.state.permissions.canAddInformesAuditorias
    }
  }
}
</script>
